import _objectWithoutProperties from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { parseByteRanges, parseContentRange, parseContentType } from './httputils';
import { BaseSource } from './basesource';
import { BlockedSource } from './blockedsource';
import { FetchClient } from './client/fetch';
import { XHRClient } from './client/xhr';
import { HttpClient } from './client/http';
var RemoteSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(RemoteSource, _BaseSource);
  /**
   *
   * @param {BaseClient} client
   * @param {object} headers
   * @param {numbers} maxRanges
   * @param {boolean} allowFullFile
   */
  function RemoteSource(client, headers, maxRanges, allowFullFile) {
    var _this;
    _classCallCheck(this, RemoteSource);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RemoteSource).call(this));
    _this.client = client;
    _this.headers = headers;
    _this.maxRanges = maxRanges;
    _this.allowFullFile = allowFullFile;
    _this._fileSize = null;
    return _this;
  }

  /**
   *
   * @param {Slice[]} slices
   */
  _createClass(RemoteSource, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(slices, signal) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.maxRanges >= slices.length)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", this.fetchSlices(slices, signal));
              case 4:
                if (this.maxRanges > 0 && slices.length > 1) {
                  // TODO: split into multiple multi-range requests

                  // const subSlicesRequests = [];
                  // for (let i = 0; i < slices.length; i += this.maxRanges) {
                  //   subSlicesRequests.push(
                  //     this.fetchSlices(slices.slice(i, i + this.maxRanges), signal),
                  //   );
                  // }
                  // return (await Promise.all(subSlicesRequests)).flat();
                }
              case 5:
                return _context.abrupt("return", Promise.all(slices.map(function (slice) {
                  return _this2.fetchSlice(slice, signal);
                })));
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchSlices",
    value: function () {
      var _fetchSlices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(slices, signal) {
        var _this3 = this;
        var response, _parseContentType, type, params, byteRanges, data, _parseContentRange, start, end, total, first, others, _data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.request({
                  headers: _objectSpread({}, this.headers, {
                    Range: "bytes=".concat(slices.map(function (_ref) {
                      var offset = _ref.offset,
                        length = _ref.length;
                      return "".concat(offset, "-").concat(offset + length);
                    }).join(','))
                  }),
                  signal: signal
                });
              case 2:
                response = _context2.sent;
                if (response.ok) {
                  _context2.next = 7;
                  break;
                }
                throw new Error('Error fetching data.');
              case 7:
                if (!(response.status === 206)) {
                  _context2.next = 32;
                  break;
                }
                _parseContentType = parseContentType(response.getHeader('content-type')), type = _parseContentType.type, params = _parseContentType.params;
                if (!(type === 'multipart/byteranges')) {
                  _context2.next = 18;
                  break;
                }
                _context2.t0 = parseByteRanges;
                _context2.next = 13;
                return response.getData();
              case 13:
                _context2.t1 = _context2.sent;
                _context2.t2 = params.boundary;
                byteRanges = (0, _context2.t0)(_context2.t1, _context2.t2);
                this._fileSize = byteRanges[0].fileSize || null;
                return _context2.abrupt("return", byteRanges);
              case 18:
                _context2.next = 20;
                return response.getData();
              case 20:
                data = _context2.sent;
                _parseContentRange = parseContentRange(response.getHeader('content-range')), start = _parseContentRange.start, end = _parseContentRange.end, total = _parseContentRange.total;
                this._fileSize = total || null;
                first = [{
                  data: data,
                  offset: start,
                  length: end - start
                }];
                if (!(slices.length > 1)) {
                  _context2.next = 29;
                  break;
                }
                _context2.next = 27;
                return Promise.all(slices.slice(1).map(function (slice) {
                  return _this3.fetchSlice(slice, signal);
                }));
              case 27:
                others = _context2.sent;
                return _context2.abrupt("return", first.concat(others));
              case 29:
                return _context2.abrupt("return", first);
              case 32:
                if (this.allowFullFile) {
                  _context2.next = 34;
                  break;
                }
                throw new Error('Server responded with full file');
              case 34:
                _context2.next = 36;
                return response.getData();
              case 36:
                _data = _context2.sent;
                this._fileSize = _data.byteLength;
                return _context2.abrupt("return", [{
                  data: _data,
                  offset: 0,
                  length: _data.byteLength
                }]);
              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function fetchSlices(_x3, _x4) {
        return _fetchSlices.apply(this, arguments);
      }
      return fetchSlices;
    }()
  }, {
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(slice, signal) {
        var offset, length, response, data, _parseContentRange2, total, _data2;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                offset = slice.offset, length = slice.length;
                _context3.next = 3;
                return this.client.request({
                  headers: _objectSpread({}, this.headers, {
                    Range: "bytes=".concat(offset, "-").concat(offset + length)
                  }),
                  signal: signal
                });
              case 3:
                response = _context3.sent;
                if (response.ok) {
                  _context3.next = 8;
                  break;
                }
                throw new Error('Error fetching data.');
              case 8:
                if (!(response.status === 206)) {
                  _context3.next = 17;
                  break;
                }
                _context3.next = 11;
                return response.getData();
              case 11:
                data = _context3.sent;
                _parseContentRange2 = parseContentRange(response.getHeader('content-range')), total = _parseContentRange2.total;
                this._fileSize = total || null;
                return _context3.abrupt("return", {
                  data: data,
                  offset: offset,
                  length: length
                });
              case 17:
                if (this.allowFullFile) {
                  _context3.next = 19;
                  break;
                }
                throw new Error('Server responded with full file');
              case 19:
                _context3.next = 21;
                return response.getData();
              case 21:
                _data2 = _context3.sent;
                this._fileSize = _data2.byteLength;
                return _context3.abrupt("return", {
                  data: _data2,
                  offset: 0,
                  length: _data2.byteLength
                });
              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function fetchSlice(_x5, _x6) {
        return _fetchSlice.apply(this, arguments);
      }
      return fetchSlice;
    }()
  }, {
    key: "fileSize",
    get: function get() {
      return this._fileSize;
    }
  }]);
  return RemoteSource;
}(BaseSource);
function maybeWrapInBlockedSource(source, _ref2) {
  var blockSize = _ref2.blockSize,
    cacheSize = _ref2.cacheSize;
  if (blockSize === null) {
    return source;
  }
  return new BlockedSource(source, blockSize, cacheSize);
}
export function makeFetchSource(url) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$headers = _ref3.headers,
    headers = _ref3$headers === void 0 ? {} : _ref3$headers,
    credentials = _ref3.credentials,
    _ref3$maxRanges = _ref3.maxRanges,
    maxRanges = _ref3$maxRanges === void 0 ? 0 : _ref3$maxRanges,
    _ref3$allowFullFile = _ref3.allowFullFile,
    allowFullFile = _ref3$allowFullFile === void 0 ? false : _ref3$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref3, ["headers", "credentials", "maxRanges", "allowFullFile"]);
  var client = new FetchClient(url, credentials);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}
export function makeXHRSource(url) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$headers = _ref4.headers,
    headers = _ref4$headers === void 0 ? {} : _ref4$headers,
    _ref4$maxRanges = _ref4.maxRanges,
    maxRanges = _ref4$maxRanges === void 0 ? 0 : _ref4$maxRanges,
    _ref4$allowFullFile = _ref4.allowFullFile,
    allowFullFile = _ref4$allowFullFile === void 0 ? false : _ref4$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref4, ["headers", "maxRanges", "allowFullFile"]);
  var client = new XHRClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}
export function makeHttpSource(url) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$headers = _ref5.headers,
    headers = _ref5$headers === void 0 ? {} : _ref5$headers,
    _ref5$maxRanges = _ref5.maxRanges,
    maxRanges = _ref5$maxRanges === void 0 ? 0 : _ref5$maxRanges,
    _ref5$allowFullFile = _ref5.allowFullFile,
    allowFullFile = _ref5$allowFullFile === void 0 ? false : _ref5$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref5, ["headers", "maxRanges", "allowFullFile"]);
  var client = new HttpClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}

/**
 *
 * @param {string} url
 * @param {object} options
 */
export function makeRemoteSource(url) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref6$forceXHR = _ref6.forceXHR,
    forceXHR = _ref6$forceXHR === void 0 ? false : _ref6$forceXHR,
    clientOptions = _objectWithoutProperties(_ref6, ["forceXHR"]);
  if (typeof fetch === 'function' && !forceXHR) {
    return makeFetchSource(url, clientOptions);
  }
  if (typeof XMLHttpRequest !== 'undefined') {
    return makeXHRSource(url, clientOptions);
  }
  return makeHttpSource(url, clientOptions);
}